<template>
        <div class="container">
            <images></images>
        </div>
</template>
<script>
import Modals from "./JavascriptComponents/Modals";
import Images from "./JavascriptComponents/Images";

export default {
  components: {
    Images,
    Modals,
  }
};
</script>
<style>
</style>
